import React from 'react'

import './Slide.scss'

const Slide = ({ name, content, contentHover, onClick }) => (
    <div className="add-new-slide__slide">
        <div className="add-new-slide__slide__box" onClick={onClick}>
            <div className="add-new-slide__slide__content">{content}</div>
            <div className="add-new-slide__slide__content_hover">{contentHover}</div>
        </div>
        <p>{name}</p>
    </div>
)

export default Slide
